<template>
  <div class="premiumchart_wrapper package_10000">
    <div class="title_wrapper">
      <h1>{{ kind }}USDT Premium Chart</h1>
      <div class="chart-type-selector">
        <div class="chart-tab flex-center">
          <!-- <label for="lite" class="flex-center tab-selector on">
            <input
              type="radio"
              id="lite"
              name="chart-select"
              checked
              value="lite"
              v-model="chartTab"
            />
            Lite
          </label>
          <label for="pro" class="flex-center tab-selector">
            <input
              type="radio"
              id="pro"
              name="chart-select"
              value="pro"
              v-model="chartTab"
            />
            Pro
          </label> -->
          <label
            v-for="tab in ['lite', 'pro']"
            :key="tab"
            :class="['tab-selector flex-center', { on: chartTabIndex === tab }]"
          >
            <input
              type="radio"
              name="chart-select"
              :id="tab"
              :value="tab"
              v-model="chartTabIndex"
              @change="onTabChange(tab)"
            />
            <img
              v-if="chartTabIndex === tab"
              src="@/assets/images/icons/check_orange.svg"
              alt=""
            />
            <img v-else :src="isDarkMode ? checkIconW : checkIcon" alt="" />
            {{ tab }}
          </label>
        </div>
      </div>
    </div>
    <div
      style="width: 100%"
      class="pmUo_wrapper"
      :class="{ new_uo_wrapper: !storeIsMobile }"
    >
      <div
        id="pmLightweight_uo"
        style="width: 100%; position: relative"
        ref="chartContainer"
      >
        <div class="autoScaleBox">
          <span class="autoScaleBtn">Auto</span>
        </div>
        <!-- <div class="loading-wrapper">
                        <div class="loading-container">
                            <img src="../image/loading.png"></img>
                            <p>Loading...</p>
                        </div>
                    </div> -->
      </div>
    </div>
  </div>
  <ModalAlert
    :isVisible="alertDialog.isVisible"
    :content="alertDialog.content"
    @closeDialogHandler="alertDialog.isVisible = false"
    :is-btn="true"
  />
</template>

<script setup>
import ModalAlert from "@/components/common/modal/ModalAlert.vue";
import { DateUtil } from "@/utils/chart/date_class.js";
import { isMobile, checkDecimal } from "@/utils/chartUtil.js";
import checkIconW from "@/assets/images/icons/check.svg";
import checkIcon from "@/assets/images/icons/check_bk.svg";

import {
  onMounted,
  onUnmounted,
  ref,
  defineProps,
  defineEmits,
  watch,
  onBeforeUnmount,
  computed,
  reactive,
  nextTick,
} from "vue";
import { getInitCandleLast } from "@/api/apiChart.js";
import pmChartOptions from "@/js/chart/premium/premium_chart_options.js";
import pmChartAPI from "@/js/chart/premium/premium_chart_api.js";
import { appendLegend, updateLegend } from "@/utils/chart/set_legend.js";
import {
  createToolBox,
  setAutoBtn,
  drawingToolHandler,
  fullScreenHandler,
  resizeOverlay,
  setupEventHandlers,
  createMeasureButton,
} from "@/utils/chart/set_tool_premium.js";
import { setCheckBoxLayout, setCheckBox } from "@/utils/chart/set_checkbox.js";
import { useStore } from "vuex";
// import LightweightCharts from "@/plugin/lightweight_dev.js";
import { useI18n } from "vue-i18n";
import { createChart } from "lightweight-charts";

const { t } = useI18n();
const store = useStore();
const isDarkMode = computed(() => store.getters["displayed/isDarkMode"]);

// State
const alertDialog = ref({
  isVisible: false,
  content: "",
});
const state = reactive({ isFull: false, adjustedHeight: 0 });
const pmIsHeikin = ref(false);
// const chartTabIndex = ref("lite");
const chartTabIndex = ref(localStorage.getItem("pmChartTabIndex") || "lite");
const userAuth = computed(() => store.state.account.userAuth);
const pmCheckList = ref([]);
const checkedList = ref([]);
const pmChart = ref(null);
// const candlestickSeries = ref(null);
let candlestickSeries;
const checkEl = ref();

const chart_wrapper = ref(null);
const pmContainer = ref(null);
const selectContainer = ref(null);

const pmChartAPIClass = new pmChartAPI();
const pmChartInstance = new pmChartOptions();

const storeIsMobile = computed(() => store.state.account.isMobile);
const props = defineProps({
  kind: String,
});

const kind = ref(props.kind);

// const kind = computed(() => store.getters["transact/getTicker"]);
const windowWidth = window.innerWidth;

const ogProCheckList = [
  {
    key: "PREMIUMCHANNEL",
    checked: true,
    value: "Premium Channel",
    desc: t("chart.premiumChannelDesc"),
  },
  { key: "MA3", checked: false, value: "3MA", desc: t("chart.maDesc") },
  { key: "BB", checked: false, value: "BB", desc: t("chart.goyaLineDesc") },
  { key: "VOLV", checked: false, value: "Trend", desc: t("chart.trendDesc") },
  { key: "SR", checked: false, value: "S/R", desc: t("chart.srDesc") },
  { key: "HEI", checked: false, value: "Heikin", desc: t("chart.heiDesc") },
  { key: "RSI", checked: false, value: "RSI", desc: t("chart.rsiDesc") },
  { key: "MACD", checked: false, value: "MACD", desc: t("chart.macdDesc") },
  // { key: "RLS", checked: true, value: "RLS", desc: "" },
  { key: "All", checked: false, value: "All", desc: "" },
];
const ogLiteCheckList = [
  {
    key: "PINK",
    checked: true,
    value: "GOYA LINE",
    desc: t("chart.goyaLineDesc"),
  },
  {
    key: "VOLV",
    checked: false,
    value: "Trend",
    desc: t("chart.trendDesc"),
  },
  { key: "SR", checked: false, value: "S/R", desc: t("chart.srDesc") },
  { key: "All", checked: false, value: "All", desc: "" },
];

// premium chart
pmCheckList.value = ogLiteCheckList;

let pmFetchList = [
  {
    key: "AO",
    series: [
      {
        name: "aoSeries",
        type: "baseLine",
        option: "aoSeriesOptions",
        key: "ao",
      },
    ],
  },
  {
    key: "PREMIUMCHANNEL",
    series: [
      { name: "pinkLine", type: "line", option: "pinkOptions", key: "pink" },
    ],
  },
  {
    key: "PINK",
    series: [
      { name: "pinkLine", type: "line", option: "pinkOptions", key: "pink" },
    ],
  },
  {
    key: "MA3",
    url: "ma",
    series: [
      { name: "MA1Line", type: "line", option: "Ma1Options", key: "ma1" },
      { name: "MA2Line", type: "line", option: "Ma2Options", key: "ma2" },
      { name: "MA3Line", type: "line", option: "Ma3Options", key: "ma3" },
    ],
  },
  {
    key: "BB",
    url: "bb",
    series: [
      { name: "UpperLine", type: "line", option: "UpperOptions", key: "upper" },
      { name: "LowerLine", type: "line", option: "LowerOptions", key: "lower" },
    ],
  },
  {
    key: "VOLV",
    url: "/analysis/multiple-trend",
    series: [
      {
        name: "trendUpper52",
        type: "line",
        option: "TrendUpper52Options",
        key: "upper",
        value: "52",
      },
      {
        name: "trendMiddle52",
        type: "line",
        option: "TrendMiddle52Options",
        key: "middle",
        value: "52",
      },
      {
        name: "trendLower52",
        type: "line",
        option: "TrendLower52Options",
        key: "lower",
        value: "52",
      },
      {
        name: "trendUpper100",
        type: "line",
        option: "TrendUpper100Options",
        key: "upper",
        value: "100",
      },
      {
        name: "trendMiddle100",
        type: "line",
        option: "TrendMiddle100Options",
        key: "middle",
        value: "100",
      },
      {
        name: "trendLower100",
        type: "line",
        option: "TrendLower100Options",
        key: "lower",
        value: "100",
      },
    ],
  },
  {
    key: "SR",
    url: "/candle/sr",
  },
  {
    key: "RSI",
    url: "/candle/rsi",
    series: [
      { name: "RSILine", type: "line", option: "RSILineOptions", key: "rsi" },
      {
        name: "MACDRSILineBlue",
        type: "line",
        option: "MACDRSILineBlueOptions",
        key: "blue_line",
      },
      {
        name: "MACDRSILineOrange",
        type: "line",
        option: "MACDRSILineOrangeOptions",
        key: "orange_line",
      },
    ],
  },
  {
    key: "MACD",
    url: "macd",
    series: [
      {
        name: "MACDHistogram",
        type: "histogram",
        option: "MACDHistogramOptions",
        key: "macd",
      },
      {
        name: "MACDLineBlue",
        type: "line",
        option: "MACDLineBlueOptions",
        key: "blue_line",
      },
      {
        name: "MACDLineOrange",
        type: "line",
        option: "MACDLineOrangeOptions",
        key: "orange_line",
      },
    ],
  },
  {
    key: "RLS",
  },
];

let chart;

onMounted(async () => {
  chart_wrapper.value = document.querySelector(".pmUo_wrapper");
  pmContainer.value = document.getElementById("pmLightweight_uo");
  selectContainer.value = document.createElement("div");
  selectContainer.value.className = "select_container browser pm";

  // 체크박스 초기화
  setCheckBox(
    chart_wrapper.value,
    pmCheckList.value,
    "pm",
    selectContainer.value,
  );
  setCheckBoxLayout(
    chart_wrapper.value,
    pmContainer.value,
    pmCheckList.value,
    "pm",
    state,
    selectContainer.value,
  );

  checkEl.value = chart_wrapper.value.querySelectorAll(
    "input[type='checkbox']",
  );
  checkedList.value = [
    ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
  ].map((e) => e.id);

  // 차트 및 시리즈 생성
  chkBoxHandler();

  await init(kind.value);

  await nextTick();

  let legend = document.createElement("div");
  appendLegend(pmContainer.value, "premium", legend);

  // setTimeout(() => {
  chart.subscribeCrosshairMove((param) => {
    // if (param.time == undefined) return;
    updateLegend(param, candlestickSeries, legend, kind.value);
  });
  // }, 0);

  updateLegend(undefined, candlestickSeries, legend, kind.value);

  createToolBox(pmContainer.value);
  setAutoBtn(pmContainer.value, chart);
  drawingToolHandler(pmContainer.value, chart, candlestickSeries);
  fullScreenHandler(state, chart_wrapper.value, pmContainer.value, chart);
  setupEventHandlers(pmContainer.value, chart, candlestickSeries);
  createMeasureButton(pmContainer.value);

  window.addEventListener("resize", resizeHandler);
});

// watch(
//   () => isDarkMode.value,
//   (newVal) => {
//     if (selectContainer.value) {
//       selectContainer.value.className = `select_container browser pm ${
//         newVal ? "dark" : "light"
//       }`;
//     }
//   },
// );

onUnmounted(() => {
  window.removeEventListener("resize", resizeHandler);
  clearInterval(intervalId);
});
function resizeHandler() {
  // 리사이즈 시 실행할 코드
  setCheckBox(
    chart_wrapper.value,
    pmCheckList.value,
    "premium",
    selectContainer.value,
  );
  setCheckBoxLayout(
    chart_wrapper.value,
    pmContainer.value,
    pmCheckList.value,
    "premium",
    state,
    selectContainer.value,
  );
  chkBoxHandler();
  resizeOverlay(pmContainer.value, "premium");
}

let eachPmCheckLists = {
  pro: null,
  lite: null,
};

async function resetIndicatorForSeries(seriesKeys) {
  for (const key of seriesKeys) {
    const chartObj = getSeries(key);
    if (chartObj && chartObj.series) {
      await pmChartAPIClass.resetIndicator(chartObj.series);
    }
  }
}

const onTabChange = async (tab) => {
  if (tab == "pro") {
    if (!userAuth.value.pmPro) {
      alertDialog.value.isVisible = true;
      alertDialog.value.content = t("alert.upgradePro");
      return;
    }
  }
  chartTabIndex.value = tab;

  await resetIndicatorForSeries(["PREMIUMCHANNEL", "PINK"]);

  eachPmCheckLists[chartTabIndex.value] = pmCheckList.value;

  let exceptList = ["MA3", "BB", "MACD", "RSI", "HEI", "RLS"]; // for lite chart displaying (exclude checkbox)

  if (chartTabIndex.value == "pro") {
    pmCheckList.value.forEach(async (chkBox) => {
      if (exceptList.includes(chkBox.key)) {
        if (chkBox.key != "HEI") {
          await setEachIndicator(chkBox.key, false);
        } else {
          await pmChartAPIClass.getCandle(kind.value, candlestickSeries, false);
          candlestickSeries.setData(candlestickSeries.data());
        }
      }
    });
    await pmChartAPIClass.getRLSSignalMarkers(
      kind.value,
      candlestickSeries,
      "none",
      false,
    );

    await pmChartAPIClass.getRLSLineData(kind.value, chart, false);
  }

  let savedProCheckedList = localStorage.getItem("pmProCheckedList");
  let savedLiteCheckedList = localStorage.getItem("pmLiteCheckedList");

  if (eachPmCheckLists[chartTabIndex.value]) {
    pmCheckList.value = eachPmCheckLists[tab];

    if (chartTabIndex.value) {
      if (chartTabIndex.value == "pro") {
        // console.log("pro");
        // pmCheckList.value = ogProCheckList;
        // pmChartAPIClass.setPriceScale(
        //   savedProCheckedList ? savedProCheckedList : ogProCheckList,
        //   { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
        //   chart
        // );

        pmCheckList.value = ogProCheckList;

        if (savedProCheckedList) {
          savedProCheckedList = savedProCheckedList.split(",");

          if (!savedProCheckedList.includes("PREMIUMCHANNEL")) {
            // chart_wrapper.value.querySelector(`#PINK`).checked = false;
            pmCheckList.value[0].checked = false;

            // pmCheckList[0].checked = false;

            let chartObj = getSeries("PREMIUMCHANNEL");
            let seriesObj = chartObj.series;

            await pmChartAPIClass.resetIndicator(seriesObj);
          }

          pmCheckList.value.forEach((checkbox) => {
            if (savedProCheckedList.includes(checkbox.key)) {
              checkbox.checked = true;
            }
          });

          pmChartAPIClass.setPriceScale(
            savedProCheckedList ? savedProCheckedList : ogProCheckList,
            { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
            chart,
          );
        }

        const pmIsHeikin =
          pmCheckList.value.find((item) => item.key === "HEI")?.checked ===
          true;

        await pmChartAPIClass.getCandle(
          kind.value,
          candlestickSeries,
          pmIsHeikin,
        );
      } else if (chartTabIndex.value == "lite") {
        // console.log("lite");
        pmCheckList.value = ogLiteCheckList;

        await resetIndicatorForSeries([
          "PREMIUMCHANNEL",
          "MA3",
          "BB",
          "VOLV",
          "SR",
          "HEI",
          "RSI",
          "MACD",
          "All",
        ]);

        await pmChartAPIClass.getRLSSignalMarkers(
          kind.value,
          candlestickSeries,
          "none",
          false,
        );
        await pmChartAPIClass.getRLSLineData(kind.value, chart, false);

        if (savedLiteCheckedList) {
          savedLiteCheckedList = savedLiteCheckedList.split(",");
          if (!savedLiteCheckedList.includes("PINK")) {
            // chart_wrapper.value.querySelector(`#PINK`).checked = false;
            pmCheckList.value[0].checked = false;

            // pmCheckList[0].checked = false;

            let chartObj = getSeries("PINK");
            let seriesObj = chartObj.series;

            await pmChartAPIClass.resetIndicator(seriesObj);
          }

          pmCheckList.value.forEach((checkbox) => {
            if (savedLiteCheckedList.includes(checkbox.key)) {
              checkbox.checked = true;
            }
          });

          pmChartAPIClass.setPriceScale(
            savedLiteCheckedList ? savedLiteCheckedList : ogLiteCheckList,
            { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
            chart,
          );
        }

        await pmChartAPIClass.getCandle(kind.value, candlestickSeries, false);
      }

      const allChecked = pmCheckList.value
        .slice(0, pmCheckList.value.length - 1)
        .every((checkbox) => checkbox.checked);

      if (allChecked) {
        // "All" 체크박스도 체크하기
        const allCheckbox = pmCheckList.value.find(
          (checkbox) => checkbox.key === "All",
        );
        if (allCheckbox) {
          allCheckbox.checked = true;
        }
      }
    }
  } else {
    // console.log(1);

    watch(chartTabIndex.value, async (newData) => {
      if (newData == "pro") {
        // console.log(12);
        pmCheckList.value = ogProCheckList;

        if (savedProCheckedList) {
          savedProCheckedList = savedProCheckedList.split(",");

          if (!savedProCheckedList.includes("PREMIUMCHANNEL")) {
            // chart_wrapper.value.querySelector(`#PINK`).checked = false;
            pmCheckList.value[0].checked = false;

            // pmCheckList[0].checked = false;

            let chartObj = getSeries("PREMIUMCHANNEL");
            let seriesObj = chartObj.series;

            await pmChartAPIClass.resetIndicator(seriesObj);
          }

          pmCheckList.value.forEach((checkbox) => {
            if (savedProCheckedList.includes(checkbox.key)) {
              checkbox.checked = true;
            }
          });

          pmChartAPIClass.setPriceScale(
            savedProCheckedList,
            { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
            chart,
          );
        }

        const pmIsHeikin =
          pmCheckList.value.find((item) => item.key === "HEI")?.checked ===
          true;

        await pmChartAPIClass.getCandle(
          kind.value,
          candlestickSeries,
          pmIsHeikin,
        );
      } else if (newData == "lite") {
        pmCheckList.value = ogLiteCheckList;

        if (savedLiteCheckedList) {
          savedLiteCheckedList = savedLiteCheckedList.split(",");
          if (!savedLiteCheckedList.includes("PINK")) {
            // chart_wrapper.value.querySelector(`#PINK`).checked = false;
            pmCheckList.value[0].checked = false;

            // pmCheckList[0].checked = false;

            let chartObj = getSeries("PINK");
            let seriesObj = chartObj.series;

            await pmChartAPIClass.resetIndicator(seriesObj);
          }

          pmCheckList.value.forEach((checkbox) => {
            if (savedLiteCheckedList.includes(checkbox.key)) {
              checkbox.checked = true;
            }
          });

          pmChartAPIClass.setPriceScale(
            savedLiteCheckedList,
            { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
            chart,
          );
        }

        await pmChartAPIClass.getCandle(kind.value, candlestickSeries, false);
      }
    });

    // switch (chartTabIndex.value) {
    //   case "pro": {
    //     console.log(12);
    //     pmCheckList.value = ogProCheckList;

    //     if (savedProCheckedList) {
    //       savedProCheckedList = savedProCheckedList.split(",");

    //       if (!savedProCheckedList.includes("PREMIUMCHANNEL")) {
    //         // chart_wrapper.value.querySelector(`#PINK`).checked = false;
    //         pmCheckList.value[0].checked = false;

    //         // pmCheckList[0].checked = false;

    //         let chartObj = getSeries("PREMIUMCHANNEL");
    //         let seriesObj = chartObj.series;

    //         await pmChartAPIClass.resetIndicator(seriesObj);
    //       }

    //       pmCheckList.value.forEach((checkbox) => {
    //         if (savedProCheckedList.includes(checkbox.key)) {
    //           checkbox.checked = true;
    //         }
    //       });

    //       pmChartAPIClass.setPriceScale(
    //         savedProCheckedList,
    //         { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
    //         chart
    //       );
    //     }

    //     const pmIsHeikin =
    //       pmCheckList.value.find((item) => item.key === "HEI")?.checked ===
    //       true;

    //     await pmChartAPIClass.getCandle(
    //       kind.value,
    //       candlestickSeries,
    //       pmIsHeikin.value
    //     );

    //     break;
    //   }
    //   case "lite": {
    //     pmCheckList.value = ogLiteCheckList;

    //     if (savedLiteCheckedList) {
    //       savedLiteCheckedList = savedLiteCheckedList.split(",");
    //       if (!savedLiteCheckedList.includes("PINK")) {
    //         // chart_wrapper.value.querySelector(`#PINK`).checked = false;
    //         pmCheckList.value[0].checked = false;

    //         // pmCheckList[0].checked = false;

    //         let chartObj = getSeries("PINK");
    //         let seriesObj = chartObj.series;

    //         await pmChartAPIClass.resetIndicator(seriesObj);
    //       }

    //       pmCheckList.value.forEach((checkbox) => {
    //         if (savedLiteCheckedList.includes(checkbox.key)) {
    //           checkbox.checked = true;
    //         }
    //       });

    //       pmChartAPIClass.setPriceScale(
    //         savedLiteCheckedList,
    //         { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
    //         chart
    //       );
    //     }

    //     await pmChartAPIClass.getCandle(
    //       kind.value,
    //       candlestickSeries,
    //       false
    //     );

    //     break;
    //   }
    // }

    const allChecked = pmCheckList.value
      .slice(0, pmCheckList.value.length - 1)
      .every((checkbox) => checkbox.checked);

    if (allChecked) {
      // "All" 체크박스도 체크하기
      const allCheckbox = pmCheckList.value.find(
        (checkbox) => checkbox.key === "All",
      );
      if (allCheckbox) {
        allCheckbox.checked = true;
      }
    }
  }

  localStorage.setItem("pmChartTabIndex", chartTabIndex.value);

  setCheckBox(
    chart_wrapper.value,
    pmCheckList.value,
    "pm",
    selectContainer.value,
  );
  setCheckBoxLayout(
    chart_wrapper.value,
    pmContainer.value,
    pmCheckList.value,
    "pm",
    state,
    selectContainer.value,
  );
  // console.log('pmCheckList',pmCheckList);
  pmIsHeikin.value = [
    ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
  ]
    .map((e) => e.id)
    .includes("HEI");

  pmCheckList.value.forEach(async (chkBox) => {
    if (chkBox.key == "All") {
      chart_wrapper.value.querySelector(`#${chkBox.key}`).checked =
        getChkBox("All").checked; // if all checked , need  to set all checkbox checked
    }
    if (chkBox.key != "HEI") {
      await setEachIndicator(
        chkBox.key,
        chart_wrapper.value.querySelector(`#${chkBox.key}`).checked,
      );
    } else {
      await pmChartAPIClass.getCandle(
        kind.value,
        candlestickSeries,
        chart_wrapper.value.querySelector(`#${chkBox.key}`).checked,
      );
      candlestickSeries.setData(candlestickSeries.data());
    }
  });
  checkedList.value = [
    ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
  ].map((e) => e.id);

  pmChartAPIClass.displayCheckStatus(
    chartTabIndex.value,
    checkedList.value,
    pmFetchList,
  ); // charttab , macd , rsi, ao coditional displaying
  chkBoxHandler();
};
let chartContainer = ref();

async function init(kind) {
  // 차트 생성

  const getInitCandleLastClose = await getInitCandleLast(kind);

  // const chartOptions = ref({
  //   trackingMode: {
  //     exitMode: 1,
  //   },
  //   kineticScroll: {
  //     mouse: true,
  //   },
  //   // width: '90%',
  //   height: windowWidth <= 576 || isMobile() ? 500 : 700,
  //   autoSize: true,
  //   //ao
  //   leftPriceScale: {
  //     borderVisible: true,
  //     visible: false,
  //     scaleMargins: {
  //       //가격축 간격
  //       top: 0.8,
  //       bottom: 0.0,
  //     },
  //     ticksVisible: true,
  //   },
  //   //캔들
  //   rightPriceScale: {
  //     // autoScale:true,
  //     visible: true,
  //     borderColor: "#383F59",
  //     scaleMargins: {
  //       top: 0.1,
  //       bottom: 0.2,
  //     },
  //     ticksVisible: true,
  //   },
  //   layout: {
  //     background: { color: "#282828" },
  //     textColor: "#fff",
  //     // fontSize:18
  //     attributionLogo: false,
  //   },
  //   grid: {
  //     vertLines: {
  //       color: "#383F59",
  //     },
  //     horzLines: {
  //       color: "#383F59",
  //     },
  //   },
  //   timeScale: {
  //     //hour축 간격
  //     barSpacing: 11, // barSpacing 값을 11.15로 변경
  //     timeVisible: true,
  //     // borderColor: '#505050',
  //     tickMarkFormatter(time, tickMarkType, locale) {
  //       return DateUtil.convertTimeScale(time);
  //     },
  //     rightOffset: 20,
  //   },
  //   crosshair: {
  //     mode: 0, // CrosshairMode.Normal
  //   },
  //   localization: {
  //     // locale:navigator.language
  //     timeFormatter(originalTime, timeZone) {
  //       return DateUtil.convertTimeScaleWithLocal(originalTime, timeZone);
  //     },
  //   },
  // });
  const priceFormat = checkDecimal(getInitCandleLastClose.close);
  // chart = createChart(chartContainer.value, chartOptions.value);
  chart = await pmChartInstance.createChart("pmLightweight_uo");
  if (pmChartInstance.chart) {
    const newHeight = windowWidth <= 576 || isMobile() ? 500 : 700;
    pmChartInstance.chart.resize(
      pmChartInstance.chartOptions.width || pmChartInstance.chartWidth || 0,
      newHeight,
    );
  }

  candlestickSeries = await pmChartInstance.createSeries(
    chart,
    "candle",
    "candleOptions",
    priceFormat,
  );

  const savedTab = localStorage.getItem("pmChartTabIndex");
  // 체크리스트 저장값 불러오기
  let savedProCheckedList = localStorage.getItem("pmProCheckedList");
  let savedLiteCheckedList = localStorage.getItem("pmLiteCheckedList");

  pmFetchList.forEach((obj) => {
    if (obj.series?.length > 0) {
      obj.series.forEach((series) => {
        series.name = pmChartInstance.createSeries(
          chart,
          series.type,
          series.option,
          priceFormat,
          obj.key,
        );
      });
    }
  });

  if (savedTab === "pro") {
    document.getElementById("lite").parentElement.classList.remove("on");
    document.getElementById("pro").parentElement.classList.add("on");

    document.querySelector("#lite").checked = false;
    document.querySelector("#pro").checked = true;
    chartTabIndex.value = "pro";

    // 기본 pro 체크박스 세팅
    pmCheckList.value = ogProCheckList;

    // 체크박스 UI 그리기
    setCheckBox(
      chart_wrapper.value,
      pmCheckList.value,
      "pm",
      selectContainer.value,
    );
    setCheckBoxLayout(
      chart_wrapper.value,
      pmContainer.value,
      pmCheckList.value,
      "pm",
      state,
      selectContainer.value,
    );

    // 저장된 체크리스트 적용
    if (savedProCheckedList) {
      savedProCheckedList = savedProCheckedList.split(",");

      // 저장된 항목들 체크 상태 반영
      pmCheckList.value.forEach((checkbox) => {
        checkbox.checked = savedProCheckedList.includes(checkbox.key);
      });

      // PREMIUMCHANNEL이 체크 해제된 경우 초기화
      if (!savedProCheckedList.includes("PREMIUMCHANNEL")) {
        await pmChartAPIClass.getRLSSignalMarkers(
          kind,
          candlestickSeries,
          "none",
          false,
        );
        await pmChartAPIClass.getRLSLineData(kind, chart, false);
        let chartObj = getSeries("PREMIUMCHANNEL");
        if (chartObj?.series) {
          await pmChartAPIClass.resetIndicator(chartObj.series);
        }
      }

      pmIsHeikin.value =
        pmCheckList.value.find((item) => item.key === "HEI")?.checked === true;

      // 보조지표 스케일 적용 (MACD, RSI용)
      pmChartAPIClass.setPriceScale(
        savedProCheckedList,
        { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
        chart,
      );
    }
  } else {
    // Lite 모드
    // $("#pro").parent().removeClass("on");
    document.getElementById("pro").parentElement.classList.remove("on");

    // $("#lite").parent().addClass("on");
    document.getElementById("lite").parentElement.classList.add("on");

    document.querySelector("#pro").checked = false;
    document.querySelector("#lite").checked = true;
    chartTabIndex.value = "lite";

    // 기본 lite 체크박스 세팅
    pmCheckList.value = ogLiteCheckList;

    setCheckBox(
      chart_wrapper.value,
      pmCheckList.value,
      "pm",
      selectContainer.value,
    );
    setCheckBoxLayout(
      chart_wrapper.value,
      pmContainer.value,
      pmCheckList.value,
      "pm",
      state,
      selectContainer.value,
    );

    if (savedLiteCheckedList) {
      savedLiteCheckedList = savedLiteCheckedList.split(",");

      pmCheckList.value.forEach((checkbox) => {
        checkbox.checked = savedLiteCheckedList.includes(checkbox.key);
      });

      // PINK가 체크 해제된 경우 초기화
      if (!savedLiteCheckedList.includes("PINK")) {
        let chartObj = getSeries("PINK");
        if (chartObj?.series) {
          await pmChartAPIClass.resetIndicator(chartObj.series);
        }
      }
    }
  }

  await pmChartAPIClass.getCandle(kind, candlestickSeries, pmIsHeikin.value);

  // 마커 세팅
  await pmChartAPIClass.getMarkers(kind, getSeries("AO"));
  await pmChartAPIClass.getSignalMarkers(kind, candlestickSeries, "none");

  // 최종 체크박스 상태 적용 + setEachIndicator 한번만 호출
  for (const chkBox of pmCheckList.value) {
    const checkboxElement = chart_wrapper.value.querySelector(`#${chkBox.key}`);
    if (checkboxElement) {
      checkboxElement.checked = chkBox.checked;

      if (chkBox.key !== "HEI") {
        await setEachIndicator(chkBox.key, chkBox.checked);
        // await pmChartAPIClass.getCandle(kind, candlestickSeries, false);
      } else {
        await setEachIndicator(chkBox.key, chkBox.checked);

        // await pmChartAPIClass.getCandle(kind, candlestickSeries, true);
        candlestickSeries.setData(candlestickSeries.data());
      }
    }
  }

  // All 체크박스 상태 자동 세팅
  const allChecked = pmCheckList.value
    .slice(0, pmCheckList.value.length - 1)
    .every((checkbox) => checkbox.checked);

  if (allChecked) {
    const allCheckbox = chart_wrapper.value.querySelector(`#All`);
    if (allCheckbox) {
      allCheckbox.checked = true;
    }
  }

  // Heikin 상태 업데이트
  pmIsHeikin.value = [
    ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
  ]
    .map((e) => e.id)
    .includes("HEI");

  // 현재 체크리스트 기준으로 display 조정
  checkedList.value = [
    ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
  ].map((e) => e.id);

  pmChartAPIClass.displayCheckStatus(
    chartTabIndex.value,
    checkedList.value,
    pmFetchList,
  );

  // 체크박스 이벤트 핸들러 등록
  chkBoxHandler();
}

function chkBoxHandler() {
  checkEl.value = chart_wrapper.value.querySelectorAll(
    "input[type='checkbox']",
  );
  // console.log('checkEl.value',checkEl.value);

  checkEl.value.forEach((chkBox) => {
    chkBox.addEventListener("change", async function () {
      let totalpmCheckList = pmCheckList.value.map((e) => e.key);
      checkedList.value = [
        ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
      ].map((e) => e.id);
      pmIsHeikin.value = [
        ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
      ]
        .map((e) => e.id)
        .includes("HEI");
      if (this.id == "HEI" || this.id == "All") {
        pmIsHeikin.value = chartTabIndex.value == "pro" ? this.checked : false;
        await pmChartAPIClass.getCandle(
          kind.value,
          candlestickSeries,
          pmIsHeikin.value,
        );
        pmCheckList.value.forEach(async (chkBox) => {
          if (this.id == "All") {
            chart_wrapper.value.querySelector(`#${chkBox.key}`).checked =
              this.checked;
            chkBox.checked = this.checked;
          }

          await setEachIndicator(
            chkBox.key,
            chart_wrapper.value.querySelector(`#${chkBox.key}`).checked,
          );
        });
        checkedList.value = [
          ...chart_wrapper.value.querySelectorAll(
            "input[type=checkbox]:checked",
          ),
        ].map((e) => e.id);
        candlestickSeries.setData(candlestickSeries.data());
      } else {
        // if (this.id === "RLS") {

        //   await pmChartAPIClass.getRLSSignalMarkers(
        //     kind.value,
        //     candlestickSeries,
        //     "none"
        //   );
        // }

        await setEachIndicator(this.id, this.checked);
      }
      // all status check
      let isAllChecked = totalpmCheckList
        .filter((el) => el != "All")
        .every(
          (val) =>
            chart_wrapper.value.querySelector(`#${val}`).checked === true,
        );
      chart_wrapper.value.querySelector(`#All`).checked = isAllChecked;
      getChkBox("All").checked = isAllChecked;
      // for priceScale after check rsi,macd
      pmChartAPIClass.setPriceScale(
        checkedList.value,
        { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
        chart,
      );
      // display check status
      // if(chartTabIndex.value == 'pro'){
      pmChartAPIClass.displayCheckStatus(
        chartTabIndex.value,
        checkedList.value,
        pmFetchList,
      );
      // }
      // console.log('pmCheckList.find((id)=> id == this.id)',getChkBox(this.id));
      getChkBox(this.id).checked = this.checked;
      let savedTab = localStorage.getItem("pmChartTabIndex");
      const filteredCheckedList = checkedList.value.filter(
        (item) => item !== "All",
      );

      savedTab === "pro"
        ? localStorage.setItem("pmProCheckedList", filteredCheckedList)
        : localStorage.setItem("pmLiteCheckedList", filteredCheckedList);
    });
  });
}

async function setEachIndicator(id, checked, forceUpdate = false) {
  let chartObj = getSeries(id);
  // console.log('pmIsHeikin.value',pmIsHeikin.value,'id',id,'checked',checked);
  if (chartObj && Object.prototype.hasOwnProperty.call(chartObj, "series")) {
    let seriesObj = chartObj.series;
    if (id == "PREMIUMCHANNEL") {
      await pmChartAPIClass.getRLSSignalMarkers(
        kind.value,
        candlestickSeries,
        "none",
        checked,
        forceUpdate,
      );
      await pmChartAPIClass.getRLSLineData(
        kind.value,
        chart,
        checked,
        forceUpdate,
      );
      // if (!checked) {
      //   await pmChartAPIClass.resetIndicator(seriesObj);
      // }
    }

    if (checked) {
      if (id == "VOLV") {
        await pmChartAPIClass.getTrendLine(kind.value, chartObj);
      } else if (id == "MACD") {
        await pmChartAPIClass.getMACD(kind.value, pmIsHeikin.value, chartObj);
      } else if (id == "RSI") {
        let macdSeries = getSeries("MACD").series;
        let isMacdLoad = await pmChartAPIClass.isInitLoad(
          macdSeries,
          pmIsHeikin.value,
          "MACD",
        );
        // console.log('isMacdLoad',isMacdLoad);
        if (isMacdLoad) {
          await pmChartAPIClass.getMACD(
            kind.value,
            pmIsHeikin.value,
            getSeries("MACD"),
            true,
          );
        }

        await pmChartAPIClass.getRSI(kind.value, pmIsHeikin.value, chartObj);
      } else {
        await pmChartAPIClass.getIndicator(
          kind.value,
          pmIsHeikin.value,
          chartObj,
        );
      }
    } else {
      await pmChartAPIClass.resetIndicator(seriesObj);
    }
  } else {
    if (id == "SR") {
      await pmChartAPIClass.getSr(
        chartObj.url,
        kind.value,
        candlestickSeries,
        checked,
      );
    }
  }
}

function getChkBox(id) {
  return pmCheckList.value.find((obj) => obj.key == id);
}

function getSeries(id) {
  return pmFetchList.find((obj) => obj.key == id);
}

// watch(kind, async (newKind) => {
//   console.log("Ticker changed to:", newKind);
//   await init(newKind);
// });

let intervalId = setInterval(async () => {
  await pmChartAPIClass.updateChart(pmFetchList);
  pmIsHeikin.value = [
    ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
  ]
    .map((e) => e.id)
    .includes("HEI");
  await pmChartAPIClass.getCandle(kind.value, candlestickSeries, false);
  await pmChartAPIClass.getCandle(
    kind.value,
    candlestickSeries,
    pmIsHeikin.value,
  );
  candlestickSeries.setData(candlestickSeries.data());
  await pmChartAPIClass.getMarkers(kind.value, getSeries("AO"));
  await pmChartAPIClass.getSignalMarkers(kind.value, candlestickSeries, "none");
  pmCheckList.value.forEach(async (chkBox) => {
    await setEachIndicator(
      chkBox.key,
      chart_wrapper.value.querySelector(`#${chkBox.key}`).checked,
      true,
    );
  });

  pmChartAPIClass.displayCheckStatus(
    chartTabIndex.value,
    checkedList.value,
    pmFetchList,
  );
}, 300000);
//300000
</script>

<style scoped>
@import "@/assets/css/renewal_design.css";
@import "@/assets/css/setting_design.css";

.new_uo_wrapper {
  height: 700px !important;
}

.main-wrapper.chart-container > div {
  width: 100%;
  padding: 32px 48px;
}

.main-wrapper > div:not(.left-pos) {
  border-radius: 4px;
  border: 0.25px solid var(--bs-body-bg);
  background: var(--chart-bg-color);
  /* box-shadow: -8px 8px 8px 0 rgba(0, 0, 0, 0.2); */
  backdrop-filter: blur(15px);
}

@media screen and (max-width: 768px) {
  .main-wrapper.chart-container > div {
    width: 100%;
    padding: 0 !important;
  }

  .main-wrapper > div:not(.left-pos) {
    border: none;
    background: transparent;
  }
}
</style>
